<template>
  <div>
    <h1 class="centertext">
      Featured Public Rooms
    </h1>
    <input placeholder="Find Your Cell Game Room with Search 🔍" class="cell-game-room" type="text" v-model="query" @input="search($event.target.value)">

    <div class="gap"></div>
    <!-- <div>
      Search
    </div> -->
    <!-- <input type="text" v-model="query" @input="search($event.target.value)"> -->
    <div class="grey-area">
      <div class="game-items">
        <div class="search">
          <div class="game-room-block" :key="game._id" v-for="game in getList()">
            <div class="game-title action" @click="enterRoom({ game })">
              <span v-if="game.enableEntryPassword">
                <img class="inline-icon" src="../img/password.svg" alt="">
              </span>
              {{ game.displayName }} <img class="inline-icon" src="../img/goright.svg" />
            </div>

            <div class="game-room-size">
              <span>
                <img class="inline-icon" src="../img/player.svg" alt="">
              </span>
              <span>
                Players: <PlayerCounter :gameID="game._id"></PlayerCounter>
              </span>
            </div>

            <div class="game-room-size">
              Room Size: {{ game.width }}x{{ game.height }}
            </div>
          </div>
        </div>
      </div>
      <!-- <div :key="game._id" v-for="game in getList()">
        <router-link :to="`/buhk-cloud/play/${game._id}`">{{ game.displayName }}</router-link>
        <pre>{{ game }}</pre>
      </div> -->
    </div>

    <!-- !!!!!!!!!!!!!!!! -->

  </div>
</template>

<script>
import * as sAPI from '../api/strapi'
import _ from 'lodash'
import PlayerCounter from './PlayerCounter.vue'
export default {
  components: {
    PlayerCounter
  },
  data () {
    return {
      query: '',
      searches: false,
      pinned: false,
      pinIDs: []
    }
  },
  mounted () {
    this.getPinnedStuff()
  },
  methods: {
    // enterRoom ({ game }) {
    //   let gameID = game._id
    //   this.$router.push(`/buhk-cloud/play/${gameID}`)
    // },
    enterRoom ({ game }) {
      let gameID = game._id
      if (game.flags.variant === 'buhk') {
        this.$router.push(`/buhk-cloud/play/${gameID}`)
      } else {
        this.$router.push(`/cloud/play/${gameID}`)
      }
    },
    getList () {
      if (this.query) {
        return this.searches
      } else {
        return this.pinned
      }
    },
    search: _.debounce(function (val) {
      this.getPinnedStuff()
      sAPI.searchRoomList({ displayName: val })
        .then((val) => {
          this.searches = val
        })
    }, 500),
    getPinnedStuff (val) {
      sAPI.getPinnedIDs()
        .then((val) => {
          this.pinIDs = val
          return sAPI.getPinnedDetails({ ids: val.map(v => v.gameID) })
        })
        .then((val) => {
          this.pinned = val
        })
    }
  }
}
</script>

<style>

</style>
